var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('div',{staticClass:"mb-6"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.addBankPayment.apply(null, arguments)}}},[_c('img',{staticClass:"w-full md:w-1/3 lg:w-1/4",attrs:{"src":"/assets/images/profile/payment/bank.png","alt":""}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }